import axios from 'axios';

import { API_URL } from '../../router/constants/constants';
import { SemesterAttendanceStatsResponseDto } from '../../types/dto/statistics.dto';

export class Statistics {
  async getSemesterStatistics(
    subjectId: string,
    lecturerPin: string,
    monthOffset: number
  ): Promise<SemesterAttendanceStatsResponseDto> {
    const params = new URLSearchParams();
    params.append('subjectId', subjectId);
    params.append('lecturerPin', lecturerPin);
    params.append('monthOffset', monthOffset.toString());

    const response = await axios({
      method: 'GET',
      url: `${API_URL}/api/admin/attendance-stats/semester-attendance-stats`,
      responseType: 'json',
      params,
    });

    return response.data;
  }
}
